(function() {
  function processCard(card) {
    if (card.dataset.badgeProcessed) return;
    if (card.closest('[class*="quiver"], [id*="quiver"], [data-quiver]')) return;
    const productLink = card.querySelector('a[href*="/products/"]');
    if (!productLink) return;
    const handle = productLink.getAttribute('href').split('/products/')[1].split('?')[0].split('#')[0];
    if (!handle) return;
    card.dataset.badgeProcessed = 'true';
    fetch(`/products/${handle}.js`)
      .then(r => r.json())
      .then(product => {
        if (!product.tags || !product.tags.includes('subscription')) return;
        const isLoopBundleChild = product.metafields && (
          product.metafields.loop?.bundle_child ||
          product.metafields.loop?.is_bundle_child ||
          product.metafields['loop-bundles']?.bundle_child ||
          product.metafields['loop-bundles']?.is_bundle_child
        );
        const isLoopProductType = product.product_type && (
          product.product_type.toLowerCase().includes('loop bundle') ||
          product.product_type.toLowerCase().includes('bundle component')
        );
        if (isLoopBundleChild || isLoopProductType) return;
        let discountPercent = '10';
        if (product.selling_plan_groups && product.selling_plan_groups.length > 0) {
          const spg = product.selling_plan_groups[0];
          if (spg.selling_plans && spg.selling_plans.length > 0) {
            const adj = spg.selling_plans[0].price_adjustments?.[0];
            if (adj && adj.value_type === 'percentage') discountPercent = adj.value;
          }
        }
        const imageContainer = card.querySelector('figure.product-card-figure, .card__media, .product__media')
          || card.querySelector('img')?.parentElement;
        if (imageContainer && !imageContainer.querySelector('.subscription-badge')) {
          const badge = document.createElement('div');
          badge.className = 'subscription-badge';
          badge.innerHTML = `Subscribe<br>& Save<br>${discountPercent}%`;
          imageContainer.style.position = 'relative';
          imageContainer.appendChild(badge);
        }
      })
      .catch(err => console.error('Badge error:', err));
  }

  function addBadges() {
    document.querySelectorAll('.product-list li.product, .product-card, .card-wrapper, .grid-product, .product-item')
      .forEach(processCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addBadges);
  } else {
    addBadges();
  }

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches('.product-list li.product, .product-card, .card-wrapper, .grid-product, .product-item')) {
          processCard(node);
        }
        node.querySelectorAll?.('.product-list li.product, .product-card, .card-wrapper, .grid-product, .product-item')
          .forEach(processCard);
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  let pollCount = 0;
  const poll = setInterval(() => {
    addBadges();
    if (++pollCount >= 20) clearInterval(poll);
  }, 500);
})();
